var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.83398 9.16602H7.50065V10.8327H5.83398V9.16602ZM5.83398 12.4993H7.50065V14.166H5.83398V12.4993ZM9.16732 9.16602H10.834V10.8327H9.16732V9.16602ZM9.16732 12.4993H10.834V14.166H9.16732V12.4993ZM12.5007 9.16602H14.1673V10.8327H12.5007V9.16602ZM12.5007 12.4993H14.1673V14.166H12.5007V12.4993Z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.16667 18.3327H15.8333C16.7525 18.3327 17.5 17.5852 17.5 16.666V4.99935C17.5 4.08018 16.7525 3.33268 15.8333 3.33268H14.1667V1.66602H12.5V3.33268H7.5V1.66602H5.83333V3.33268H4.16667C3.2475 3.33268 2.5 4.08018 2.5 4.99935V16.666C2.5 17.5852 3.2475 18.3327 4.16667 18.3327ZM15.8333 6.66602L15.8342 16.666H4.16667V6.66602H15.8333Z",
    fill: "#9CA3AF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.44fd2fd558faa562810d8a0103211d06.svg";
export { ForwardRef as ReactComponent };